export default "__VITE_ASSET__DGOJV9d0__"